import { Box, Button, Layer, ResponsiveContext } from "grommet";
import { Add } from "grommet-icons";
import React, { useContext, useState } from "react";
import { CompanyListing } from "../components/CompanyListing";
import { CreatePCompany } from "../components/CreatePCompany";
import { UserContext } from "../contexts/UserContext";
import { useCompaniesQuery } from "../generated/graphql";

interface Props {}

export const PortoflioCompaniesPage: React.FC<Props> = () => {
  const { user } = useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const { data } = useCompaniesQuery({
    variables: { type: "portfolio" },
    fetchPolicy: "network-only"
  });
  if (!data) {
    return null;
  }
  return (
    <>
      <ResponsiveContext.Consumer>
        {size => {
          return (
            <Box>
              <Box
                direction="row"
                justify="between"
                style={{ marginBottom: "30px" }}
              >
                <h1>Portföljbolag</h1>
                {user && user.isAdmin && (
                  <Button
                    icon={<Add />}
                    label="Lägg till"
                    onClick={() => {
                      setShowModal(true);
                    }}
                  />
                )}
              </Box>
              {data.companies && (
                <Box style={{ flexShrink: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      marginLeft: `${size !== "small" ? "-20px" : "0"}`,

                      marginRight: `${size !== "small" ? "-20px" : "0"}`,
                      paddingBottom: "100px"
                    }}
                  >
                    <CompanyListing
                      companies={data.companies}
                      grid={size !== "small" ? true : false}
                    />
                  </div>
                </Box>
              )}

              {showModal && (
                <Layer
                  onEsc={() => setShowModal(false)}
                  onClickOutside={() => setShowModal(false)}
                >
                  <CreatePCompany
                    showModal={showModal}
                    setShowModal={setShowModal}
                  />
                </Layer>
              )}
            </Box>
          );
        }}
      </ResponsiveContext.Consumer>
    </>
  );
};
